/**
 * Created by JasonChou on 17/6/19.
 */
import React, {PureComponent} from 'react'
import Button from './Button'
export default class CaptchaBtn extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            init: false,
            waiting: 0,
            loading: false
        };
    }

    render() {
        let title;
        if (!this.state.waiting)
            title = this.state.init ? '重新获取' : '获取验证码';
        else {
            title = `等待${this.state.waiting}秒`;

            if (!this.handler)
                this.handler = setInterval(() => {
                    console.log(this.state.waiting);
                    if (this.state.waiting)
                        this.setState({waiting: this.state.waiting - 1});
                    else {
                        clearInterval(this.handler);
                        this.handler = null
                    }

                }, 1000)
        }
        const {newStyle, onClick, ...o} = this.props;

        return <Button style={Object.assign({width: 100, textAlign: 'center'}, newStyle)}  {...o}
                       onClick={async (e) => {
                           if (!this.state.loading) {
                               this.setState({loading: true});
                               const success = await onClick(e);
                               this.setState({
                                   loading: false,
                                   waiting: success ? 60 : 0,
                                   init: this.state.init || success
                               });
                           }
                       }}>{title}</Button>
    }
}


// WEBPACK FOOTER //
// ./src/components/CaptchaBtn.js